import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ArrangementResponseData } from '@shared/model/arrangement-response.model';
import { BulkTypeResponseDataModel } from '@shared/model/bulk-type-response.model';
import { CurrenciesResponseDataModel } from '@shared/model/currencies-response.model';
import { HsCodeResponseData } from '@shared/model/hscode-response.model';
import { UnitsResponseData } from '@shared/model/units-response.model';
import { Observable, Subject, of } from 'rxjs';
import { QuotePersistService } from '../quote-persist.service';
import { BaseInfoService } from '@api/base-info.service';
import { MatStepper } from '@angular/material/stepper';
import { QuoteExtraService } from '@shared/services/quote-extra-services.service';
import { HscodeService } from '@shared/services/hscode.service';

@Component({
  selector: 'app-quote-goods-info',
  templateUrl: './quote-goods-info.component.html',
  styleUrls: ['./quote-goods-info.component.scss']
})
export class QuoteGoodsInfoComponent implements OnInit {

  language = 'fa';
  editGoods = false;
  faTitleArrangement;
  filteredOptions?: Observable<HsCodeResponseData[]>;
  searchDisabled: boolean;
  hsCodeTypeId
  currencyTypeId;
  netWeight = false;
  isPerishable = false;
  canceled = false;
  goods: Array<any> = [];
  numberGoods = 0;
  totalWeight = 0;
  valueGoods = 0;
  editNumber = 500;
  edit = false;
  isDesktop = true;
  isDocument = false;
  emptyPrice = false;
  loadTypeId = 0;
  countUnitOptions: UnitsResponseData[] = [];
  arrangements: ArrangementResponseData[] = [];
  bulkTypes: BulkTypeResponseDataModel[] = [];
  hsCode: HsCodeResponseData[];
  currencies: CurrenciesResponseDataModel[] = [];
  public destroy$ = new Subject<void>();
  formGroup: FormGroup;
  expressStatus = false;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private quotePersistService: QuotePersistService,
    public baseInfoService: BaseInfoService,
    public stepper: MatStepper,
    public quoteExtra: QuoteExtraService,
    public router: Router,
    private hscodeService: HscodeService

  ) { }
  ngOnInit() {
    this.getInitialForm();
    this.fillQuoteRequestFields();
    this.patchFormWithCache();
    this.calculateValue();
    this.getValueDocument();
    this.getExpress();
    this.addValidatorWithConditional();
  }
  getInitialForm() {
    this.formGroup = this.formBuilder.group({
      hsCode: [null],
      unitTypeId: [null, [Validators.required]],
      quantity: [null, [Validators.required]],
      length: [null, []],
      width: [null, []],
      height: [null, []],
      weigth: [null, [Validators.required]],
      price: [null, [Validators.required]],
      arrangementTypeId: [null, []],
      isDangerous: [false, []],
      isPerishable: [false, []],
      hsCodeTypeId: [null, []],
      name: [null, [Validators.required]],
      hasMagnet: [false, []],
      hasBattery: [false, []],
      hasLiquid: [false, []],
      brandGood: [false, []],
      arrangementCount: [null, [Validators.required]],

    });
  }
  getExpress() {
    const url = this.router.url;
    this.expressStatus = url.includes('express');
    if (this.expressStatus) {
      this.addFormControlInExpress();
    }
  }
  addFormControlInExpress() {
    this.formGroup.addControl('hasMagnet', this.formBuilder.control(false));
    this.formGroup.addControl('hasBattery', this.formBuilder.control(false));
    this.formGroup.addControl('hasLiquid', this.formBuilder.control(false));
    this.formGroup.addControl('brandGood', this.formBuilder.control(false));
  }
  rrrr(event) {
    switch (event.value) {
      case 1:
        this.faTitleArrangement = 'پلی بگ';
        break;
      case 2:
        this.faTitleArrangement = ' کارتن';
        break;
      case 3:
        this.faTitleArrangement = 'بشکه';
        break;
      case 4:
        this.faTitleArrangement = 'عدل';
        break;
      case 5:
        this.faTitleArrangement = 'بندیل';
        break;
      case 6:
        this.faTitleArrangement = 'نگله';
        break;
      case 7:
        this.faTitleArrangement = 'بیگ بگ';
        break;
      case 8:
        this.faTitleArrangement = 'رول';
        break;
      case 9:
        this.faTitleArrangement = 'کارتن پالت';
        break;
      case 10:
        this.faTitleArrangement = 'بسته بندی چوبی';
        break;
      case 11:
        this.faTitleArrangement = 'فلکسی تانک';
        break;
      case 12:
        this.faTitleArrangement = 'گونی';
        break;
      case 13:
        this.faTitleArrangement = 'گالن';
        break;
      case 14:
        this.faTitleArrangement = 'قرقره';
        break;
    }
    return this.faTitleArrangement;
  }
  addFormControlInHsCodeManual() {
    this.hsCodeTypeId = JSON.parse(localStorage.getItem('hsCodeTypeId'));
    if (this.hsCodeTypeId === 0) {
      this.formGroup.controls.hsCodeTypeId.patchValue(0)
    } else if (this.hsCodeTypeId === 1) {
      this.formGroup.controls.hsCodeTypeId.patchValue(1)
    }
  }
  addValidatorWithConditional() {
    if (!this.expressStatus) {
      this.formGroup.get('arrangementTypeId').addValidators(Validators.required);
    }
    if (this.expressStatus) {
      this.formGroup.get('arrangementTypeId').clearValidators();
    }
    this.formGroup.controls.arrangementTypeId.updateValueAndValidity();
  }
  fillQuoteRequestFields() {
    this.quotePersistService.getQuoteRequestFields().subscribe(res => {
      this.countUnitOptions = res?.units;
      this.arrangements = res?.arrangements;
      this.currencies = res?.currencies;
      this.bulkTypes = res?.bulkTypes;
    });
  }
  patchFormWithCache() {
    const cache = (this.quotePersistService.getFromLS('goods-info'));
    if (!!cache) {
      this.goods = cache?.goods
      this.currencyTypeId = cache?.currencyTypeId;
    }
  }
  calculateValue() {
    this.totalWeight = 0;
    this.valueGoods = 0;
    this.numberGoods = this.goods?.length;
    if (this.goods[this.numberGoods - 1] !== undefined && this.editGoods === false) {
      (this.goods[this.numberGoods - 1]).weigth = +parseInt(this.goods[this.goods?.length - 1]?.weigth);
      this.goods.forEach(element => {
        this.totalWeight += (+element.weigth);
      });
      (this.goods[this.numberGoods - 1]).price = +parseInt(this.goods[this.goods?.length - 1]?.price?.replace(/[^0-9]/gi, ''), 10);
      this.goods.forEach(element => {
        this.valueGoods += (+element.price);
      });
    } else if (this.goods[this.numberGoods - 1] !== undefined && this.editGoods === true) {
      (this.goods[this.numberGoods - 1]).weigth = +parseInt(this.goods[this.goods?.length - 1]?.weigth);
      this.goods.forEach(element => {
        this.totalWeight += (+element.weigth);
      });
      (this.goods[this.numberGoods - 1]).price = +parseInt(this.goods[this.goods?.length - 1]?.price, 10);
      this.goods.forEach(element => {
        this.valueGoods += (+element.price);
      });
    }

  }
  getValueDocument() {
    this.quoteExtra.getDocument().subscribe((res: any) => {
      this.isDocument = res;
    });
    this.fixDataDocument();
  }
  fixDataDocument() {
    if (this.isDocument) {
      this.formGroup.controls.hsCode.patchValue('');
      this.formGroup.controls.hsCode.disable();
      this.formGroup.controls.unitTypeId.patchValue(3);
      this.formGroup.controls.unitTypeId.disable();
      this.formGroup.controls.price.patchValue('');
      this.formGroup.controls.arrangementTypeId.patchValue('');
      this.formGroup.controls.isPerishable.patchValue('');
      this.formGroup.controls.isDangerous.patchValue('');
      this.goods = [];
    } else {
      this.formGroup.controls.hsCode.patchValue('');
      this.formGroup.controls.hsCode.enable();
      this.formGroup.controls.unitTypeId.enable();
    }
  }

  addGood() {
    this.addFormControlInHsCodeManual();
    if (!this.isDocument) {
      // this.formGroup.get('hsCode').addValidators(Validators.required);
    }
    if (this.isDocument) {
      this.formGroup.controls.price.patchValue(0);
      this.formGroup.controls.arrangementTypeId.patchValue(0);
    }
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      if (!this.isDocument) {
        // this.formGroup.controls.price.patchValue(Number(this.formGroup.controls.price.value.replace(/,/g, '')));
      }
      this.goods.push(this.formGroup.value);
      this.formGroup.reset();
      this.getTitle(null);
      this.clearSearch(null);
      this.edit = false;
      if (this.isDocument) {
        this.formGroup.controls.unitTypeId.patchValue(3);
      }
      this.calculateValue();
    }
    localStorage.removeItem('hsCodeTypeId');
  }
  deleteGood(event, index) {
    for (let i = 0; i < this.goods.length; i++) {
      if (i === index) {
        this.goods.splice(i, 1);
        this.calculateValue();
      }
    }
  }
  convertToCommas(value) {
    return value.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  editGood(event, index) {
    this.editNumber = index;
    this.edit = true;
    this.canceled = false;
    this.formGroup.patchValue(this.goods[index]);
    this.formGroup.controls.price.setValue(
      this.formGroup.get('price').value.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','));

  }
  saveGood() {
    this.editGoods = true
    if (!this.isDocument) {
      this.formGroup.controls.price.patchValue(Number(this.formGroup.controls.price.value.replace(/,/g, '')));
    }
    if (this.isDocument) {
      this.formGroup.controls.unitTypeId.patchValue(3);
    }

    this.goods.splice(this.editNumber, 1, this.formGroup.value);
    this.calculateValue();
    this.formGroup.reset();
    this.getTitle(null);
    this.clearSearch(null);
    this.editNumber = 500;
    this.edit = false;
  }
  getTitle(port) {
    if (port?.hscode_segment) {
      return port?.hscode_segment + '' + port?.title;
    } else {
      return null;
    }
  }
  cancel() {
    this.canceled = true;
    this.formGroup.reset();
    if (this.isDocument) {
      this.formGroup.controls.unitTypeId.patchValue(3);
    }
  }
  changUnitType(event) {
    if (event.value === 1 || event.value === 2) {
      this.netWeight = true;
    }
    else {
      this.netWeight = false;
    }
  }
  onInputChange(event) {
    const hs = this.formGroup.value.hsCode;
    if (hs.length > 2) {
      if (isNaN(Number(hs))) {
        return this.getHsCode(true, hs);
      }
      return this.getHsCode(false, hs);
    }
  }
  getHsCode(isText, data): any {
    this.baseInfoService.getHsCode(isText, data).subscribe(
      result => {
        this.filteredOptions = of(result);
        if (result.length === 0) {
          this.hsCodeTypeId = 0;
        }
        else {
          this.hsCodeTypeId = 1;
        }
        this.hscodeService.setHsCode(this.hsCodeTypeId)
      }
    );
  }

  onSelectionChange(event) {
    this.searchDisabled = true;
  }
  clearSearch(event) {
    this.searchDisabled = false;
    this.formGroup.patchValue({ hsCode: null });
    this.filteredOptions = of();

  }
  changeCurrency(e) {
    this.emptyPrice = !this.currencyTypeId;
  }
  saveToLs() {
    this.emptyPrice = !this.currencyTypeId;
    this.formGroup.get('hsCode').clearValidators();
    this.formGroup.get('unitTypeId').clearValidators();
    this.formGroup.get('quantity').clearValidators();
    this.formGroup.get('price').clearValidators();
    this.formGroup.get('arrangementTypeId').clearValidators();
    this.formGroup.get('name').clearValidators();
    const goods = { goods: this.goods, currencyTypeId: this.currencyTypeId };
    // if (this.currencyTypeId !== undefined) {
    //   this.quotePersistService.saveToLS('goods-info', goods);
    //   if (this.goods.length !== 0) {
    //     this.stepper.next();
    //   }
    // }
    this.stepper.next();
  }
  numberWithCommas(e, formControl) {
    const value = e.target.value;
    this.formGroup.controls[formControl].setValue(
      value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }
  ngOnDestroy() {
    this.formGroup.reset();
  }
}
